import { Typography } from 'antd';
import styles from './HeaderSubHeader.module.css';
import React, { useEffect } from 'react';

interface Props {
  header: React.ReactNode;
  subHeader?: string;
  children?: React.ReactNode;
  classname?: string;
}

const HeaderSubHeader: React.FC<Props> = ({
  header,
  subHeader,
  children,
  classname,
}) => {
  const { Text } = Typography;
  useEffect(() => {
    window.onpopstate = () => {
      window.history.pushState(null, '', window.location.href);
    };
  }, []);
  return (
    <>
      <Text
        className={`${classname || ''} ${styles.accountSummaryTitle}`.trim()}
      >
        {header}
      </Text>

      {subHeader ? (
        <Text className={styles.accountSummarySubTitle}>
          {subHeader} {children}
        </Text>
      ) : (
        <></>
      )}
    </>
  );
};

export default HeaderSubHeader;
